module.exports = __webpack_public_path__ + "img/House3.f2b2e5e.jpg";